// 4.1
export const HALLGATOK_ARANYA_OPTIONS = {
    hu: [
    { value: 'magas', label: 'Magas (>10% a szakos hallgatókhoz képest)' },
    { value: 'kozepes', label: 'Közepes (5-10%)' },
    { value: 'alacsony', label: 'Alacsony (1-5%)' },
    { value: 'nagyon_alacsony', label: 'Nagyon alacsony (<1%)' },
    { value: 'nincs_hallgato', label: 'Nincs mobilitásban résztvevő hallgató' }
    ],
    en: [
    { value: 'magas', label: 'High (>10% relative to students of the programme)' },
    { value: 'kozepes', label: 'Moderate (5-10%)' },
    { value: 'alacsony', label: 'Low (1-5%)' },
    { value: 'nagyon_alacsony', label: 'Very low (<1%)' },
    { value: 'nincs_hallgato', label: 'No students participating in mobility programmes' }
    ]
};

export const ELOZO_EVEK_OPTIONS = {
    hu: [
    { value: 'jelentosen_novekedett', label: 'Jelentősen növekedett (>20%)' },
    { value: 'novekedett', label: 'Növekedett (10-20%)' },
    { value: 'stabil', label: 'Stabil (±10%)' },
    { value: 'csokkent', label: 'Csökkent (10-20%)' },
    { value: 'jelentosen_csokkent', label: 'Jelentősen csökkent (>20%)' },
    { value: 'nincs_adat', label: 'Nincs összehasonlítási adat' }
    ],
    en: [
    { value: 'jelentosen_novekedett', label: 'Significant increase (>20%)' },
    { value: 'novekedett', label: 'Increase (10-20%)' },
    { value: 'stabil', label: 'Stable (±10%)' },
    { value: 'csokkent', label: 'Decrease (10-20%)' },
    { value: 'jelentosen_csokkent', label: 'Significant decrease (>20%)' },
    { value: 'nincs_adat', label: 'No comparative data available' }
    ]
};

export const NEMZETKOZI_HALLGATOK_OPTIONS = {
    hu: [
    { value: 'volt', label: 'Volt bejövő nemzetközi hallgató a szakon' },
    { value: 'nem_volt', label: 'Nem volt bejövő nemzetközi hallgató' }
    ],
    en: [
    { value: 'volt', label: 'There were incoming international students enrolled in the programme' },
    { value: 'nem_volt', label: 'There were no incoming international students enrolled in the programme' }
    ]
};

export const MOBILITAS_HOZZAJARULASA_OPTIONS = {
    hu: [
    { value: 'nyelvtudas_fejlesztese', label: 'Hallgatók nyelvtudásának fejlesztése' },
    { value: 'interkultura_erositese', label: 'Interkulturális kompetenciák erősítése' },
    { value: 'kapcsolatok_epitese', label: 'Nemzetközi szakmai kapcsolatok kiépítése' },
    { value: 'ismeretek_elsajatitasa', label: 'Új módszertanok, ismeretek elsajátítása' },
    { value: 'presztizs_novelese', label: 'Szakmai presztízs növelése' },
    { value: 'elegedettseg_javitasa', label: 'Hallgatói elégedettség javítása' },
    { value: 'halozat_bovitese', label: 'Alumni és nemzetközi hálózat bővítése' },
    { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
    { value: 'nyelvtudas_fejlesztese', label: 'Development of students foreign language’ proficiency' },
    { value: 'interkultura_erositese', label: 'Strengthening of intercultural competencies' },
    { value: 'kapcsolatok_epitese', label: 'Establishment of international professional networks' },
    { value: 'ismeretek_elsajatitasa', label: 'Acquisition of new methodologies and knowledge' },
    { value: 'presztizs_novelese', label: 'Enhancement of the programme’s professional prestige' },
    { value: 'elegedettseg_javitasa', label: 'Improvement of student satisfaction' },
    { value: 'halozat_bovitese', label: 'Expansion of alumni and international networks' },
    { value: 'egyeb', label: 'Other:' }
    ]
};

// 4.2
export const MOBILITASI_ABLAK_OPTIONS = {
    hu: [
    { value: 'dedikalt_mobilitas', label: 'Dedikált mobilitási ablak a mintatervben (konkrét félév(ek) kijelölve)' },
    { value: 'rugalmas_mobilitas', label: 'Rugalmas mobilitási lehetőség több félévben' },
    { value: 'reszleges_mobilitas', label: 'Részleges mobilitási ablak (választható tárgyakkal)' },
    { value: 'tervezes_alatt', label: 'Tervezés alatt van' },
    { value: 'nincs_kialakitva', label: 'Nincs kialakítva' }
    ],
    en: [
    { value: 'dedikalt_mobilitas', label: 'Dedicated mobility window included in the sample curriculum (specific semester(s) designated)' },
    { value: 'rugalmas_mobilitas', label: 'Flexible mobility opportunities available across multiple semesters' },
    { value: 'reszleges_mobilitas', label: 'Partial mobility window (implemented through elective courses)' },
    { value: 'tervezes_alatt', label: 'Under planning' },
    { value: 'nincs_kialakitva', label: 'Not established' }
    ]
};

export const KREDIT_ELISMERES_OPTIONS = {
    hu: [
    { value: 'learning_agreement', label: 'Learning Agreement alapján előzetes elismerés' },
    { value: 'transcript_records', label: 'Transcript of Records alapján utólagos elismerés' },
    { value: 'ects_kreditek', label: 'ECTS kreditek 1:1 arányban való elismerése' },
    { value: 'tartalmi_megfeleloseg', label: 'Tartalmi megfelelőség vizsgálata alapján' },
    { value: 'szabadon_valaszthato', label: 'Szabadon választható kreditként való beszámítás' },
    { value: 'szakmai_gyakorlat', label: 'Szakmai gyakorlatként való elismerés' },
    { value: 'projektmunka_beszamitas', label: 'Projektmunkaként való beszámítás' },
    { value: 'egyeb', label: 'Egyéb:' }
    ],
    en: [
    { value: 'learning_agreement', label: 'Prior recognition based on a Learning Agreement' },
    { value: 'transcript_records', label: 'Subsequent recognition based on a Transcript of Records' },
    { value: 'ects_kreditek', label: 'Recognition of ECTS credits on a 1:1 basis' },
    { value: 'tartalmi_megfeleloseg', label: 'Recognition based on assessment of content equivalence' },
    { value: 'szabadon_valaszthato', label: 'Recognition as elective credits' },
    { value: 'szakmai_gyakorlat', label: 'Recognition as a professional internship' },
    { value: 'projektmunka_beszamitas', label: 'Recognition as project-based work' },
    { value: 'egyeb', label: 'Other:' }
    ]
};

// 4.3
export const ALTALANOS_NYELVI_OPTIONS = {
    hu: [
    { value: 'egy_ketto', label: 'Kötelező nyelvi kurzusok (1-2 félév)' },
    { value: 'harom_negy', label: 'Kötelező nyelvi kurzusok (3-4 félév)' },
    { value: 'ot_plusz', label: 'Kötelező nyelvi kurzusok (5+ félév)' },
    { value: 'valaszthato_kurzusok', label: 'Választható nyelvi kurzusok' },
    { value: 'nincs_tantervben', label: 'Nincs tantervbe épített általános nyelvi kurzus' }
    ],
    en: [
    { value: 'egy_ketto', label: 'Compulsory language courses (1-2 semesters)' },
    { value: 'harom_negy', label: 'Compulsory language courses (3-4 semesters)' },
    { value: 'ot_plusz', label: 'Compulsory language courses (5+ semesters)' },
    { value: 'valaszthato_kurzusok', label: 'Elective language courses' },
    { value: 'nincs_tantervben', label: 'No general language courses embedded in the curriculum' }
    ]
};

export const SZAKNYELVI_TARGYAK_OPTIONS = {
    hu: [
    { value: 'egy_felev', label: 'Kötelező szaknyelvi kurzus(ok) - 1 félév' },
    { value: 'ketto_felev', label: 'Kötelező szaknyelvi kurzus(ok) - 2+ félév' },
    { value: 'szaknyelvi_kurzusok', label: 'Választható szaknyelvi kurzus(ok)' },
    { value: 'nyelvi_modul', label: 'Szakspecifikus nyelvi modul' },
    { value: 'nincs_tantargy', label: 'Nincs dedikált szaknyelvi tantárgy' }
    ],
    en: [
    { value: 'egy_felev', label: 'Compulsory LSP course(s) - 1 semester' },
    { value: 'ketto_felev', label: 'Compulsory LSP course(s) - 2+ semesters' },
    { value: 'szaknyelvi_kurzusok', label: 'Elective LSP course(s)' },
    { value: 'nyelvi_modul', label: 'Discipline-specific language module' },
    { value: 'nincs_tantargy', label: 'No dedicated LSP course' }
    ]
};

export const IDEGEN_NYELV_OPTIONS = {
    hu: [
    { value: 'kotelezo_tantargyak', label: 'Igen, kötelező tantárgyak is vannak idegen nyelven' },
    { value: 'valaszthato_tantargyak', label: 'Igen, választható tantárgyak idegen nyelven' },
    { value: 'parhuzamos_program', label: 'Igen, angol nyelvű képzési program párhuzamosan' },
    { value: 'tervezes_alatt', label: 'Tervezés alatt van' },
    { value: 'nem_kinal', label: 'Nem kínál' }
    ],
    en: [
    { value: 'kotelezo_tantargyak', label: 'Yes, including compulsory courses taught in a foreign language' },
    { value: 'valaszthato_tantargyak', label: 'Yes, elective courses taught in a foreign language' },
    { value: 'parhuzamos_program', label: 'Yes, a parallel English-taught degree programme is offered' },
    { value: 'tervezes_alatt', label: 'Under development' },
    { value: 'nem_kinal', label: 'No foreign-language-taught courses offered' }
    ]
};